module.exports = __webpack_public_path__ + "img/logo.92e8caf.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 22